import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
// import ComingSoon from './Main/ComingSoon';
import Home from './Landing/Home';
import Register from './Pages/Register';
import Login from './Pages/Auth/Login';
import VerifyOtp from './Pages/VerifyOtp';
import CreateProfile from './Pages/CreateProfile';
import Dashboard from './Pages/Dashboard';
import Matches from './Pages/Matches';
import ProfileDetail from './Pages/ProfileDetail';
import Interests from './Pages/Interests';
import Settings from './Pages/Settings';
import AccountSettings from './Pages/settings/AccountSettings';
import PrivacySettings from './Pages/settings/PrivacySettings';
import NotificationSettings from './Pages/settings/NotificationSettings';
import SecuritySettings from './Pages/settings/SecuritySettings';
import MembershipSettings from './Pages/settings/MembershipSettings';
import PaymentHistorySettings from './Pages/settings/PaymentHistorySettings';
import SupportSettings from './Pages/settings/SupportSettings';
import DeleteAccountSettings from './Pages/settings/DeleteAccountSettings';
import BlockedProfilesSettings from './Pages/settings/BlockedProfilesSettings';
import ShortlistedProfilesSettings from './Pages/settings/ShortlistedProfilesSettings';
import ProfileViewsSettings from './Pages/settings/ProfileViewsSettings';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import RefundPolicy from './Pages/RefundPolicy';
import ContactUs from './Pages/ContactUs';
import AboutUs from './Pages/AboutUs';
import Pricing from './Pages/Pricing';
import RestrictedRoute from './Pages/RestrictedRoute';
import PublicOnlyRoute from './Pages/PublicOnlyRoute';


import AdminLogin from "./admin/pages/AdminLogin";
import AdminDashboard from "./admin/pages/Dashboard";
import Users from "./admin/pages/Users";
import Presence from "./admin/pages/Presence";
import AdminUserDetail from "./admin/pages/AdminUserDetail";
import AdminEditProfile from "./admin/pages/AdminEditProfile";
import Verifications from "./admin/pages/Verifications";
import AdminPayments from "./admin/pages/Payments";
import AdminCoupons from "./admin/pages/Coupons";
import AdminReports from "./admin/pages/Reports";
import AdminBanners from "./admin/pages/Banners";

import ProtectedAdminRoute from "./admin/components/ProtectedAdminRoute";
import ErrorPage from "./Main/ErrorPage";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={10}
        toastOptions={{
          duration: 2500,
          style: {
            borderRadius: '20px',
            background: '#fff',
            color: '#1F1916',
            fontSize: '13.5px',
            fontWeight: '600',
            padding: '14px 20px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)',
            border: '1px solid #f1ebe6',
            maxWidth: '360px',
          },
          success: {
            iconTheme: { primary: '#10b981', secondary: '#fff' },
            style: {
              borderLeft: '4px solid #10b981',
            },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
            style: {
              borderLeft: '4px solid #ef4444',
            },
          },
        }}
      />
      <div className="pb-24 lg:pb-0">
        <Routes>
          {/* <Route path="/" element={<ComingSoon />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
          <Route path="/register" element={<PublicOnlyRoute><Register /></PublicOnlyRoute>} />
          <Route path="/verify-otp" element={<PublicOnlyRoute><VerifyOtp /></PublicOnlyRoute>} />
          <Route path="/create-profile" element={<RestrictedRoute><CreateProfile /></RestrictedRoute>} />
          <Route path="/my-profile" element={<RestrictedRoute><CreateProfile /></RestrictedRoute>} />
          <Route path="/dashboard" element={<RestrictedRoute><Dashboard /></RestrictedRoute>} />
          <Route path="/matches" element={<RestrictedRoute><Matches /></RestrictedRoute>} />
          <Route path="/profiles/:id" element={<RestrictedRoute><ProfileDetail /></RestrictedRoute>} />
          <Route path="/interests" element={<RestrictedRoute><Interests /></RestrictedRoute>} />
          <Route path="/shortlisted" element={<RestrictedRoute><ShortlistedProfilesSettings /></RestrictedRoute>} />
          <Route path="/settings" element={<RestrictedRoute><Settings /></RestrictedRoute>} />
          <Route path="/settings/account" element={<RestrictedRoute><AccountSettings /></RestrictedRoute>} />
          <Route path="/settings/privacy" element={<RestrictedRoute><PrivacySettings /></RestrictedRoute>} />
          <Route path="/settings/blocked" element={<RestrictedRoute><BlockedProfilesSettings /></RestrictedRoute>} />
          <Route path="/settings/shortlisted" element={<RestrictedRoute><ShortlistedProfilesSettings /></RestrictedRoute>} />
          <Route path="/settings/views" element={<RestrictedRoute><ProfileViewsSettings /></RestrictedRoute>} />
          <Route path="/settings/notifications" element={<RestrictedRoute><NotificationSettings /></RestrictedRoute>} />
          <Route path="/settings/security" element={<RestrictedRoute><SecuritySettings /></RestrictedRoute>} />
          <Route path="/settings/membership" element={<RestrictedRoute><MembershipSettings /></RestrictedRoute>} />
          <Route path="/settings/payments" element={<RestrictedRoute><PaymentHistorySettings /></RestrictedRoute>} />
          <Route path="/settings/support" element={<RestrictedRoute><SupportSettings /></RestrictedRoute>} />
          <Route path="/settings/delete-account" element={<RestrictedRoute><DeleteAccountSettings /></RestrictedRoute>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/pricing" element={<Pricing />} />
           <Route path="/unauthorized" element={<ErrorPage type="403" />}/>
           <Route path="*"  element={<ErrorPage type="404" />}/>
          {/* ========================= */}
          {/* ADMIN ROUTES */}
          {/* ========================= */}

          <Route path="/admin/login" element={<PublicOnlyRoute><AdminLogin /></PublicOnlyRoute>} />

          <Route
  path="/admin/dashboard"
  element={
    <ProtectedAdminRoute>
      <AdminDashboard />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/users"
  element={
    <ProtectedAdminRoute>
      <Users />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/presence"
  element={
    <ProtectedAdminRoute>
      <Presence />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/verifications"
  element={
    <ProtectedAdminRoute>
      <Verifications />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/payments"
  element={
    <ProtectedAdminRoute>
      <AdminPayments />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/coupons"
  element={
    <ProtectedAdminRoute>
      <AdminCoupons />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/reports"
  element={
    <ProtectedAdminRoute>
      <AdminReports />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/banners"
  element={
    <ProtectedAdminRoute>
      <AdminBanners />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/users/:userId"
  element={
    <ProtectedAdminRoute>
      <AdminUserDetail />
    </ProtectedAdminRoute>
  }
/>

<Route
  path="/admin/users/:userId/edit"
  element={
    <ProtectedAdminRoute>
      <AdminEditProfile />
    </ProtectedAdminRoute>
  }
/>

        </Routes>
      </div>
    </Router>
  );
};

export default App;
